var map = {
	"./bg-exclusive.webp": 1345,
	"./border-bg-sm.png": 1346,
	"./border-bg-xm.png": 1347,
	"./border-bg.png": 1348,
	"./btn-active.png": 1349,
	"./casino-hover.webp": 1350,
	"./cny-flower-1.webp": 1351,
	"./cny-flower-2.webp": 1352,
	"./cny-mobile-bg.webp": 1353,
	"./content-deco-1.webp": 1354,
	"./content-deco-2.webp": 1355,
	"./content-deco-3.webp": 1356,
	"./content-deco-4.webp": 1357,
	"./content-deco-5.webp": 1358,
	"./deposit-icon.webp": 1359,
	"./event-border-hover.webp": 1360,
	"./games-hover.webp": 1361,
	"./home-icon-active.webp": 1362,
	"./home-icon.webp": 1363,
	"./live-icon-active.webp": 1364,
	"./live-icon.webp": 1365,
	"./lottery-hover.webp": 1366,
	"./master-bg.png": 1367,
	"./me-icon-active.webp": 1368,
	"./me-icon.webp": 1369,
	"./p2p-hover.webp": 1370,
	"./platform.webp": 1371,
	"./product-overview-bg.webp": 1372,
	"./promos-icon-active.webp": 1373,
	"./promos-icon.webp": 1374,
	"./slots-hover.webp": 1375,
	"./sponsor-icon-active.webp": 1376,
	"./sponsor-icon.webp": 1377,
	"./sports-hover.webp": 1378,
	"./title-deco-bg.webp": 1379,
	"./title-deco-left.webp": 1380,
	"./title-deco-right.webp": 1381,
	"./vip-icon-active.webp": 1382,
	"./vip-icon.webp": 1383,
	"./withdraw-icon.webp": 1384,
	"./wwr-bg.webp": 1385,
	"./wwr-img.webp": 1386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;